var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVolumeDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.00232 15.0002C4.99883 16.5372 4.93024 18.6337 5.88117 19.4174C6.76817 20.1484 7.39243 19.96 9.01181 20.0789C10.6323 20.1988 14.0524 24.9625 16.689 23.4557C18.0491 22.3862 18.1503 20.1439 18.1503 15.0002C18.1503 9.85644 18.0491 7.61419 16.689 6.54463C14.0524 5.03672 10.6323 9.80151 9.01181 9.92147C7.39243 10.0403 6.76817 9.85196 5.88117 10.5829C4.93024 11.3666 4.99883 13.4631 5.00232 15.0002Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2266 10.3931C24.8657 13.2564 24.8657 16.7532 23.2266 19.6076",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeDown);
export default __webpack_public_path__ + "static/media/Volume Down.c7ae3493.svg";
export { ForwardRef as ReactComponent };